import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';

// A shared standard view (WFC360's own): nobody can change it, only clone it or save it as a new
// view. Every user gets their own copy of each standard view, which they can change.
export const LOCKED_VIEW_HINT = "Standard view - locked. Clone it or save it as a new view to change it.";

export const LockedViewIcon = () => (
  <FontAwesomeIcon icon={faLock} title={LOCKED_VIEW_HINT} data-locked-view style={{color:'#7c98b6', fontSize:'11px', marginLeft:'6px'}}/>
);
